import React, {useCallback, useState} from "react";
import "./index.scss";
import {oneOfType, string, object, bool} from "prop-types";
import Title from "features/components/title";
import {flattenDeep} from "lodash";

export const Tabber = (props) => {
    const {children, disableTab, base_index = 0} = props;

    const [index, setIndex] = useState(base_index);

    const selectIndex = useCallback((index) => {
        /*istanbul ignore else*/
        if(!disableTab) {
            setIndex(index);
        }
    }, [setIndex, disableTab]);

    const childrens = flattenDeep(!children.length ? [children] : children);
    const current_child = childrens[index];
    return <div className="tabber">
        <div className="tab">
            {childrens.map((item, i) =>
                <div key={i} className={`item ${index === i ? "active" : ""}`} onClick={() => selectIndex(i)}>
                    <Title size={18} align={"center"}>{item.props.title}</Title>
                </div>)}
        </div>
        {current_child}
    </div>
};
Tabber.propTypes = {
    disableTab: bool
};

export const TabberChild = (props) => {
    return <div className="white-box">
        {props.children}
    </div>
}
TabberChild.propTypes = {
    title: oneOfType([string, object]).isRequired
}